"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/web.timers.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _formElements = require("@evidation/form-elements");
var _styledReactModal = _interopRequireDefault(require("styled-react-modal"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var StyledModal = _styledReactModal["default"].styled(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: white;\n  opacity: ", ";\n  transition: all ease 200ms;\n  min-width: 420px;\n\n  @media (max-width: 599px) {\n    min-width: 100%;\n    width: 100%;\n  }\n\n  @media (min-width: 850px) {\n    min-width: 500px;\n  }\n"])), function (props) {
  return props.opacity;
});
var Title = _styledComponents["default"].div.withConfig({
  displayName: "adverseModal__Title"
})(["display:flex;justify-content:space-between;padding:30px 30px;padding-left:40px;padding-bottom:5px;@media (max-width:400px){padding:30px 10px 0 30px;h2{font-size:", "rem;}}"], 20 / 16);
var Content = _styledComponents["default"].div.withConfig({
  displayName: "adverseModal__Content"
})(["font-weight:300;background:#fff;max-width:500px;padding:40px;padding-top:0px;@media (max-width:400px){padding:30px;padding-top:0;}"]);
var AdverseModal = function AdverseModal(_ref) {
  var isOpen = _ref.isOpen,
    header = _ref.header,
    content = _ref.content,
    submitting = _ref.submitting,
    remoteSubmit = _ref.remoteSubmit;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    opacity = _useState2[0],
    setOpacity = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(StyledModal, {
    isOpen: isOpen,
    opacity: opacity,
    afterOpen: function afterOpen() {
      return setTimeout(function () {
        return setOpacity(1);
      });
    },
    beforeClose: function beforeClose() {
      return new Promise(function (resolve) {
        setOpacity({
          opacity: 0
        });
        setTimeout(resolve, 200);
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(Title, null, /*#__PURE__*/_react["default"].createElement("h2", null, header)), /*#__PURE__*/_react["default"].createElement(Content, null, _lodash["default"].isString(content) ? /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, content) : content, /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    disabled: submitting,
    type: "submit",
    onClick: remoteSubmit
  }, "Continue")));
};
AdverseModal.propTypes = {
  remoteSubmit: _propTypes["default"].func
};
var _default = exports["default"] = AdverseModal;